const promoData = ref<{
    promocodeId: number;
    partnerProgramSlug: string;
    heading: string;
    subtitle: string;
    promoCode: string;
    expiresAt: string;
} | null>(null);

const isVisible = ref(false);
const isLoading = ref(false);
const isInitialized = ref(false);

export function usePromoBanner() {
    const {fetchFeaturedProgram} = usePartnerProgram();

    const fetchPromoData = async () => {
        if (!process.client || isInitialized.value) return;

        isLoading.value = true;
        try {
            const programWithPromo = await fetchFeaturedProgram();

            if (programWithPromo) {
                const {program: featuredProgram, promoCode} = programWithPromo;

                const promoBannerData = {
                    promocodeId: promoCode.id,
                    partnerProgramSlug: featuredProgram.slug,
                    heading: featuredProgram.bannerHeading || 'Специальное предложение!',
                    subtitle: featuredProgram.bannerSubtitle || 'Выберите врача со скидкой',
                    promoCode: promoCode.promoCode || `PARTNER${featuredProgram.id}`,
                    expiresAt: promoCode.expiresAt
                };

                promoData.value = promoBannerData;
                isVisible.value = true;

            } else {
                isVisible.value = false;
            }
        } catch (error) {
            console.error('Failed to fetch promo data:', error);
            isVisible.value = false;
        } finally {
            isLoading.value = false;
            isInitialized.value = true;
        }
    };

    const dismissBanner = () => {
        isVisible.value = false;
    };

    // Auto-fetch data when composable is first used
    if (process.client && !isInitialized.value) {
        fetchPromoData();
    }

    return {
        promoData: readonly(promoData),
        isVisible: readonly(isVisible),
        isLoading: readonly(isLoading),
        dismissBanner
    };
}

